import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpenEndComponent } from './components/open-end/open-end.component';
import { SingleSelectDropdownComponent } from './components/single-select-dropdown/single-select-dropdown.component';
import { SingleSelectComponent } from './components/single-select/single-select.component';
import { SplashComponent } from './components/splash/splash.component';
import { SurvayComponent } from './components/survay/survay.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';

const routes: Routes = [
  {
    path: 'browser',
    loadChildren: () =>
      import('./modules/browse-survey/browse-survey.module').then((m) => m.BrowseSurveyModule),
  },
  {path:"",redirectTo: 'utg',pathMatch: 'full'},
  {path:"utg",component:SurvayComponent},
  {path:"utg/:id",component:SurvayComponent},
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/error/error.module').then((m) => m.ErrorModule),
  },
  // {path:"",component:SurvayComponent},
  // {path:"splash",component:SplashComponent},
  // {path:"open-end",component:OpenEndComponent},
  // {path:"single-select",component:SingleSelectComponent},
  // {path:"single-select-dropdown",component:SingleSelectDropdownComponent},
  // {path:"thank-you",component:ThankYouComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
